import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchLoadOrderIfNeeded,
} from "@insite/client-framework/Store/Pages/OrderDetails/Handlers/DisplayOrder";
import loadExpediteShippingOrderHistory from "@TKCCP/Store/Data/ExpediteShippingOrderHistory/Handlers/LoadExpediteShippingOrderHistory";
import loadOrderReminder from "@TKCCP/Store/Data/OrderReminder/Handlers/LoadOrderReminder";

// addToChainBefore(chain, DispatchLoadOrderIfNeeded, props => {

//     props.dispatch(loadExpediteShippingOrderHistory({ orderNumber: props.parameter.orderNumber }));
// });

addToChainAfter(chain, DispatchLoadOrderIfNeeded, props => {
    if (props.parameter.orderNumber) {
        // 
        props.dispatch(loadOrderReminder({ orderNumber: props.parameter.orderNumber }));
        props.dispatch(loadExpediteShippingOrderHistory({ orderNumber: props.parameter.orderNumber }));
        
    }
});



// addToChainAfter(chain, DispatchLoadOrderIfNeeded, props => {
//     if (props.parameter.orderNumber) {
//         props.dispatch(loadExpediteShippingOrderHistory({ orderNumber: props.parameter.orderNumber }));
//     }
// });
